<!--
 * @Description: 图片上传组件
 * @Author: fal
 * @Date: 2024-11-25 17:21:58
 * @FilePath: \pc.ui\src\project\components\newUploaders.vue
 * @LastEditTime: 2024-12-25 15:50:25
-->
<template>
  <div>
    <div class="flex">
      <el-upload
        class="avatar-uploader"
        :class="{ hideUpload: hideUploadEdit }"
        :action="url + '/collective/file/upload'"
        :show-file-list="false"
        :auto-upload="false"
        v-loading="loading"
        :multiple="true"
        :accept="accept"
        :on-change="
          (file, fileList) => {
            handleAvatarSuccess(file, fileList);
          }
        "
        :before-upload="beforeAvatarUpload"
      >
        <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar"> -->
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div class="imgs flex" v-if="imgs.length > 0">
        <div
          v-for="(item, index) in imgs"
          class="ml-20"
          :key="index"
          :class="{ act: item.type !== 'image' && item.type !== 'video' }"
          :style="{
            width: item.type == 'image' || item.type == 'video' ? '' : 'auto',
          }"
          style="border: 1px solid #e5e5e5; width: 83px; height: 83px; border-radius: 6px"
        >
          <!-- <div style="width: 83px;height: 83px; border: 1px solid #E5E5E5;display: flex;"> -->
          <!-- <span>{{ $url+item.url }}</span> -->
          <img :src="item.url" v-if="getUrl(item) == 'png' || getUrl(item) == 'jpg'" />
          <video autopay :src="item.url" v-else-if="item.type == 'video'"></video>
          <!-- <span v-else>{{ item.url }}</span> -->
          <!-- <span>{{ item.url.split(".")[1] }}</span> -->
          <img v-if="getUrl(item) == 'xlsx'" src="@/assets/file/xlsx.png" />
          <img v-else-if="getUrl(item) == 'txt'" src="@/assets/file/txt.png" />
          <img v-else-if="getUrl(item) == 'doc'" src="@/assets/file/doc.png" />
          <img v-else-if="getUrl(item) == 'docx'" src="@/assets/file/docx.png" />
          <!-- <img v-else-if="getUrl(item) == 'png'" src="@/assets/file/png.png" /> -->
          <img v-else-if="getUrl(item) == 'zip'" src="@/assets/file/zip.png" />
          <img v-else-if="getUrl(item) == 'xls'" src="@/assets/file/xls.png" />
          <img v-else-if="getUrl(item) == 'rar'" src="@/assets/file/rar.png" />
          <img v-else-if="getUrl(item).toLowerCase() == 'pdf'" src="@/assets/file/pdf.png" />
          <img v-else-if="getUrl(item) == 'dwg'" src="@/assets/file/dwg.png" />
          <!-- </div> -->
          <i class="el-icon-circle-close cur" @click="delImg(item, index)"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imageUrl: '',
      hideUploadEdit: false,
      url: window.location.origin,
      imgs: [],
      files: [],
      loading: false,
      // imgs: []
    };
  },
  props: {
    close: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    path: {
      type: String,
      default: () => '',
    },
    list: {
      type: Array,
      default: () => [],
    },
    accept: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    close(val) {
      if (val) {
        this.imgs = [];
      }
    },
    list: {
      handler: function (val, oldVal) {
        if (this.imgs.length > 0 && this.imgs[0].url == '') this.imgs = [];
        if (val.length > 0 && this.imgs.length == 0) {
          this.imgs = [];
          val.forEach((item) => {
            let obj = {
              name: this.item.field,
              url: '',
            };
            if (!item) {
              return;
            }
            if (item.indexOf('png') > -1 || item.indexOf('jpg') > -1 || item.indexOf('jpeg') > -1 || item.indexOf('gif') > -1) {
              obj.type = 'image';
              obj.url = item;
              this.imgs.push(obj);
            } else if (item.indexOf('mp4') > -1) {
              obj.type = 'video';
              obj.url = item;
              this.imgs.push(obj);
            } else {
              obj.url = item;
              this.imgs.push(obj);
            }
          });
        }
      },
      immediate: true,
    },
    path(val) {
      this.files = [];

      if (val != '' && this.imgs.length == 0) {
        this.imgs = [];
        if (val.indexOf('png') > -1 || val.indexOf('jpg') > -1 || val.indexOf('jpeg') > -1 || val.indexOf('gif') > -1) {
          this.imgs = [{ name: this.item.field, url: val, type: 'image' }];
        } else if (val.indexOf('mp4') > -1) {
          this.imgs = [{ url: val, name: this.item.field, type: 'video' }];
        } else {
          this.imgs = [{ name: this.item.field, url: val }];
        }
      } else if (val == '') {
        this.imgs = [];
      }
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.path != '' && this.imgs.length == 0) {
        if (this.path.indexOf('png') > -1 || this.path.indexOf('jpg') > -1 || this.path.indexOf('jpeg') > -1 || this.path.indexOf('gif') > -1) {
          this.imgs = [
            {
              name: this.item.field,
              url: this.path,
              type: 'image',
            },
          ];
        } else if (this.path.indexOf('mp4') > -1) {
          this.imgs = [
            {
              url: this.path,
              name: this.item.field,
              type: 'video',
            },
          ];
        } else {
          this.imgs = [{ name: this.item.field, url: this.path }];
        }
      }
    }, 1000);
  },
  methods: {
    // 获取文件后缀名
    getUrl(item) {
      let List = item.url.split('.');
      if (List.length > 0) {
        return List[List.length - 1];
      }
    },
    // 删除图片
    delImg(item, index) {
      item.index = index;
      this.$emit('fileDel', item);
      this.imgs.splice(index, 1);
    },
    // 处理上传
    handleAvatarSuccess(file, filelist) {
      this.files = [];
      let formData = new FormData();
      formData.append('file', file.raw);
      this.loading = true;
      this.$request.post('/collective/file/upload', formData).then((res) => {
        this.loading = false;
        // 如果文件类型为image/png，则将文件路径赋值给imageUrl，并将文件信息添加到数组中
        if (file.raw.type.indexOf('image/png') > -1) {
          this.imageUrl = URL.createObjectURL(file.raw);
          this.imgs.push({ url: res, name: this.item.field, type: 'image' });
          // 如果文件类型为video，则将文件信息添加到数组中
        } else if (file.raw.type.indexOf('video') > -1) {
          this.imgs.push({ url: res, name: this.item.field, type: 'video' });
          // 否则，将文件信息添加到数组中
        } else {
          this.imgs.push({ url: res, name: this.item.field });
        }
        // 触发fileurl事件，传递文件信息
        this.$emit('fileurl', { res: res, name: this.item.field, type: this.item.type2, title: file.raw.name });
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 50;
      // 如果文件大小超过50MB，则提示错误信息
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 50MB!');
      }
      return isLt2M;
      // 返回文件大小是否小于50MB
    },
  },
};
</script>

<style lang="less" scoped>
.act {
  // width: 82px;
  //   border: 1px solid #d9d9d9;
  //   border-radius: 8px;
  //   height: 82px;
}

.over {
  width: 350px;
  line-height: 13px;

  span {
    display: inline-block;
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  i {
    margin-left: 10px;
  }
}

video {
  width: 88px;
  height: 84px;
}

.imgs div {
  position: relative;

  img {
    width: 86px;
    height: 86px;
  }

  i {
    position: absolute;
    right: -18px;
    color: #409eff;
    font-size: 18px;
  }
}
</style>
<style>
.avatar {
  width: 80px;
  height: 80px;
}

.avatar-uploader .el-upload {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  color: #e5e5e5;
  width: 83px;
  height: 83px;
  line-height: 83px;
  font-size: 40px;
  text-align: center;
}

.hideUpload {
  /deep/ .avatar-uploader-icon {
    display: none !important;
  }
}
</style>
